import { Box, ScrollView } from '@betty/moonlight';
import { State, useDispatch, useSelector } from '@betty/toolkit/state';
import { Page } from '@betty/navigation';
import { QuestDetailsEmpty } from '../components/QuestsEmptyState/QuestDetailsEmpty';
import { fetchQuests, selectQuest, selectQuestsDataState } from '../state';
import QuestItem from '../components/QuestItem/QuestItem';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import QuestSkeleton from '../components/QuestItem/components/QuestSkeleton';
function QuestDetailsPage() {
  const { id } = useParams();
  const dispatch = useDispatch();

  const quest = useSelector((state: State) => selectQuest(state, id ?? ''));

  const questsDataState = useSelector(selectQuestsDataState);

  useEffect(() => {
    if (questsDataState === 'idle') {
      dispatch(fetchQuests());
    }
  }, [dispatch, questsDataState]);

  if (questsDataState === 'idle' || questsDataState === 'pending') {
    return <QuestSkeleton />;
  }

  if (!quest || !id) {
    return <QuestDetailsEmpty />;
  }

  return (
    <Page restrictWidth>
      <ScrollView>
        <Box paddingHorizontal="space-400">
          <QuestItem id={id} detailsPageView />
        </Box>
      </ScrollView>
    </Page>
  );
}

export default QuestDetailsPage;
